import React from "react";
import { EMPTY_PERCENT_ROW } from "../acceptSupplierInvitationConstants";
import { sumPercentages } from "../acceptSupplierInvitationHelpers";

/**
 * Editable list of `{ name, percentage }` rows. Renders total% + validation
 * hint below. Used for `business_activities` and `products_or_services`
 * blocks on the accept-invitation form.
 */
const PercentRowList = ({
  label,
  rows,
  onChange,
  submitted,
  required,
  readOnly = false,
}) => {
  const total = sumPercentages(rows);
  const updateRow = (index, key, value) => {
    const next = rows.map((row, i) =>
      i === index ? { ...row, [key]: value } : row
    );
    onChange(next);
  };

  return (
    <div className="mb-3">
      <label className="st_name d-block mb-2">
        {label}
        {required ? " *" : ""}
      </label>
      {rows.map((row, index) => (
        <div className="row mb-2" key={`${label}-${index}`}>
          <div className="col-md-7">
            <input
              className="form-control name_nf"
              placeholder="Name"
              value={row.name}
              disabled={readOnly}
              readOnly={readOnly}
              onChange={(e) => updateRow(index, "name", e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <input
              className="form-control name_nf"
              type="number"
              min="0"
              max="100"
              placeholder="%"
              value={row.percentage}
              disabled={readOnly}
              readOnly={readOnly}
              onChange={(e) => updateRow(index, "percentage", e.target.value)}
            />
          </div>
          <div className="col-md-2 d-flex align-items-center">
            {rows.length > 1 && !readOnly ? (
              <button
                type="button"
                className="btn btn-link btn-sm text-danger p-0"
                onClick={() => onChange(rows.filter((_, i) => i !== index))}
              >
                Remove
              </button>
            ) : null}
          </div>
        </div>
      ))}
      <div className="d-flex justify-content-between align-items-center">
        {!readOnly ? (
          <button
            type="button"
            className="btn btn-link btn-sm p-0"
            onClick={() => onChange([...rows, EMPTY_PERCENT_ROW()])}
          >
            + Add row
          </button>
        ) : (
          <span />
        )}
        <span
          style={{
            fontSize: 12,
            color: total === 100 ? "#15803d" : "#b45309",
            fontWeight: 600,
          }}
        >
          Total: {total}%
          {submitted && total !== 100 ? " (should equal 100%)" : ""}
        </span>
      </div>
    </div>
  );
};

export default PercentRowList;
